import { FC, useEffect, useState } from "react";
import { Box } from "../../../../../components/box";
import { Table } from "antd";
import { eContent } from "../constant/field-names";

export const RecallToolList: FC<{ detail: any }> = ({ detail }) => {

  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    try {
      let eRequests = JSON.parse(detail?.fields?.eContent);
      eRequests = eRequests.map((item: any, index: number) => {
        return { ...item, index: index + 1 };
      });
      setDataSource(eRequests);
    } catch (error) {}
  }, [detail]);

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
   
    },
    {
      title: "Tên CCDC",
      dataIndex: eContent.toolName,
      key: eContent.toolName,
    },
    {
      title: "Mã CCDC",
      dataIndex: eContent.toolId,
      key: eContent.toolId,
    },
    {
      title: "ĐVT",
      dataIndex: eContent.Dram,
      key: eContent.Dram
    },
    {
      title: "Số lượng",
      dataIndex: eContent.Quantity,
      key: eContent.Quantity
    },
    {
      title: "Lí do",
      dataIndex: eContent.reason,
      key: eContent.reason,
    },
  ];

  return (
    <Box title="Danh sách CCDC đề nghị thu hồi">
      <Table dataSource={dataSource} columns={columns} />
    </Box>
  );
};
